import React from "react";
import { withFormsy } from "formsy-react";
import { FormGroup, FormFeedback, Label } from "reactstrap";
import AsyncSelect from "react-select/lib/Async";

export class AsyncSelectComponent extends React.Component {
  state = {
    selectedOption: null
  };

  changeValue = selectedOption => {
    this.setState({ selectedOption });
    this.props.setValue(selectedOption);
  };

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      loadOptions,
      validating,
      valueKey,
      labelKey,
      disabled,
      showRequired,
      showError,
      getValue,
      name,
      title,
      isPristine,
      defaultOptions,
      onChange,
      cacheOptions,
      isRequired,
      hasValue,
      isClearable
    } = this.props;
    const hasError = !isPristine() && (showError() || !hasValue());
    const { selectedOption } = this.state;
    return (
      <FormGroup>
        <Label className={isRequired() && "required"} htmlFor={name}>
          {title}
        </Label>
        <AsyncSelect
          cacheOptions={cacheOptions}
          loadOptions={loadOptions}
          value={getValue() || selectedOption}
          defaultOptions={defaultOptions}
          className={hasError ? "is-invalid" : ""}
          isDisabled={validating ? true : false || disabled}
          name={name}
          isClearable={isClearable}
          onChange={onChange || this.changeValue}
          getOptionLabel={option => option[labelKey]}
          getOptionValue={option => option[valueKey]}
        />
        {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
        {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
      </FormGroup>
    );
  }
}

const FormSelect = withFormsy(AsyncSelectComponent);

export { FormSelect as AsyncSelect };
